'use strict'

import { apiInstance, legacyV2, legacyV3 } from './index'
import { mapArgs } from 'utils/functions'

const timePolicy = {
  getTimePolicy (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/timepolicy`,
      params
    })
  },

  getTimePolicyById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/timepolicy/${id}`
    })
  },

  createTimePolicy (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/timepolicy`,
      data
    })
  },

  updateTimePolicy (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/timepolicy/${id}`,
      data
    })
  },

  setCostCenterTimePolicy (timepolicyId, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3()}/timepolicy/${timepolicyId}/costcenter`,
      data
    })
  },

  getCostCenterTimePolicyById (timePolicyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/timepolicy/${timePolicyId}/costcenter`
    })
  },

  deleteTimePolicy (id) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/timepolicy/${id}`
    })
  },

  getExceptionList (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/timepolicy/bypass`,
      params
    })
  },

  addToExceptionList (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/timepolicy/bypass`,
      data
    })
  },

  removeFromExceptionList (employeeId) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/timepolicy/bypass/${employeeId}`
    })
  }
}

export default timePolicy
